"use client"

/**
 * 子账号头像 + label 工具
 *
 * 数据主权方:账号数据(operations/accounts)
 *   - SubAccount 结构定义在这里
 *   - 头像 fallback 链(avatarUrl → category 派生默认图 → 色块首字)
 *   - 业务标签拼接 "男定制师·刘逸翔"
 *
 * 其他模块(询单中心 / 客户中心 等)直接从本文件 import,**不复制**。
 */

import { Box } from "@mui/material"

export interface SubAccount {
  id: string
  category: string                       // "男定制师" / "女定制师" / 其他
  name: string                           // 定制师姓名
  sortOrder: number
  active?: boolean
  createdAt?: string
  avatarUrl?: string | null              // public/avatars/ 相对路径
  destinationRank?: number | null
  destinationRankUpdatedAt?: string | null
}

export function subAccountLabel(sa: SubAccount): string {
  const cat = sa.category?.trim() ?? ""
  const nm = sa.name?.trim() ?? ""
  if (cat && nm) return `${cat} · ${nm}`
  return cat || nm || "未命名"
}

// fallback 链 #2:按 category 派生性别默认图
export function defaultAvatarByCategory(category: string | null | undefined): string | null {
  if (!category) return null
  if (category.includes("男")) return "/avatars/sub_male_default.jpg"
  if (category.includes("女")) return "/avatars/sub_female_default.jpg"
  return null
}

export function SubAccountAvatar({
  sub,
  size = 32,
}: {
  sub: SubAccount
  size?: number
}) {
  const initial = sub.name?.charAt(0) || sub.category?.charAt(0) || "?"
  const bgColor = sub.category?.includes("男")
    ? "#2563eb"
    : sub.category?.includes("女")
      ? "#ec4899"
      : "rgba(15,23,42,0.45)"
  const resolvedSrc = sub.avatarUrl ?? defaultAvatarByCategory(sub.category)

  if (resolvedSrc) {
    return (
      <Box
        component="img"
        src={resolvedSrc}
        alt={subAccountLabel(sub)}
        sx={{
          width: size,
          height: size,
          borderRadius: "50%",
          objectFit: "cover",
          objectPosition: "center top",
          flexShrink: 0,
          border: "1px solid rgba(15,23,42,0.08)",
        }}
      />
    )
  }
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: "50%",
        bgcolor: bgColor,
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: size * 0.4,
        fontWeight: 600,
        flexShrink: 0,
      }}
    >
      {initial}
    </Box>
  )
}
